import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import { ReduceStore } from 'flux/utils';
import update from 'immutability-helper';

class SettingStore extends ReduceStore {
    getInitialState() {
        return [];
    }

    getAll() {
        return this.getState();
    }

    getSetting(name) {
        return this.getState().find(s => s.name === name);
    }

    getValue(name, defaultValue = null) {
        const setting = this.getSetting(name);
        return setting ? setting.value : defaultValue;
    }

    getIndex(name) {
        return this._state.findIndex(s => s.name === name);
    }

    reduce(state, action) {
        let index;
        switch (action.type) {
            case ActionTypes.SETTING_LIST_SUCCESS:
                return action.data;

            case ActionTypes.SETTING_SAVE_SUCCESS:
                index = this.getIndex(action.payload.setting.name);
                return update(this.getState(), {[index]: { $set: action.data }} );

            default:
                return state;
        }
    }
}

export default new SettingStore(CentricDispatcher);
